import { render, staticRenderFns } from "./Cardiology.vue?vue&type=template&id=05c11634&scoped=true"
import script from "./Cardiology.vue?vue&type=script&lang=js"
export * from "./Cardiology.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05c11634",
  null
  
)

export default component.exports